import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionTypes } from "../constants/action-types";
import axios from "axios";

export const fetchSupermoveInventoryFromImage = createAsyncThunk(
  ActionTypes.FETCH_SUPERMOVE_INVENTORY_FROM_IMAGE,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const jwt = await localStorage.getItem("jwtToken");
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}supermove/upload-supermove-inventory`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const sendInventoryToSuperMove = createAsyncThunk(
  ActionTypes.SEND_INVENTORY_TO_SUPERMOVE,
  async (body: any, { rejectWithValue }) => {
    try {
      const jwt = await localStorage.getItem("jwtToken");
      console.log(body, "body from frontend");
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}supermove/send-inventory-to-supermove`,
        body,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
            "Content-Type": "application/json",
          },
        }
      );
      return res.data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
